import axiosInstance from 'services/axiosMiddleware';

// Updated function to accept category data
export async function createAsana(asanasdata) {
  try {
    const response = await axiosInstance.post('asana/createAsanas', asanasdata);
    return response;
    
  } catch (error) {
    console.error(error);
    throw error;
  }
}
